import { createFileRoute, redirect } from "@tanstack/react-router";

import { loaderHandler } from "src/lib/loaderHandler";
import { CreateOrganizationPage } from "src/pages/CreateOrganizationPage";

export const Route = createFileRoute("/_auth/_coach/create-org")({
  component: CreateOrganizationPage,
  ssr: true,
  loader() {
    return loaderHandler((ctx) => {
      if (!ctx.session?.entitlements.canCreateOrganizations) {
        throw redirect({ to: "/" });
      }
    });
  },
  staticData: {
    getLayoutSettings() {
      return {
        showAuthSidebar: false,
        useAuthLayout: false,
      };
    },
  },
});
